import ClockType from "../enums/clock-type";
import FieldLength from "../enums/field-length";
import GoalPost from "../enums/goal-post";
import PatPoints from "../enums/pat-points";
import ParticipationStyle from "../enums/participation-style";

const DefaultIndoorConfig = Object.freeze({
    general: {
        periodsInRegulation: 4,
        downs: 4,
        fieldLength: FieldLength.OptionTwo.code, // 50 yards
        fieldWidth: 28,
        minutesByPeriod: 15,
        firstDownYards: 10,
        // TODO: this property shouldn't be here. This is part of the flag config.
        firstDownFlagStyle: -1,
        timeoutsPerHalf: 3,
        // PSTATS-1268, see config/default.js. Needs Verification against the
        // IFL rulebook's overtime timeouts.
        otTimeouts: 1,
        redZoneLength: 20,
        zoneLength: 20,
        endZoneLength: 8,
        includeEndZoneYardage: false,
        otTimeControl: false,
        // PSTATS-1268, see config/default.js.
        otMinutesByPeriod: 10,
        autoFairCatchTb: false,
        rushType: false,
        passType: false,
        spikeTeamAttOnly: false,
        touchdownsCountAsFirstDowns: true,
        teamLossOnly: [],
        collectStatsOnPat: false,
        collectStatsForOnSideKicks: false,
        teamZoneQty: 1,
        promptToSkipKickoff: [],
        participationStyle: ParticipationStyle.Default.code
    },
    clock: {
        clockType: ClockType.DESC.code,
        runningClock: false
    },
    spots: {
        kickoff: 0, // Goal line
        kickoffOutOfBounds: 5,
        KOTouchback: 5,
        otherTouchback: 5,
        PATTry: 3,
        safetyKO: 0, // Goal line
        driveStartingYardline: 14,
        touchbackYardline: 5,
        rougeYardline: 5,
        // PSTATS-1268, see config/default.js.
        otKickoffs: false,
        overtimeStartingYardline: 10,
        spotsPatScoreOption1: 3,
        spotsPatScoreOption2: 10,
        spotsPatScoreOption3: 20,
        goalPostLocation: GoalPost.GOAL_LINE.code,
        missedFieldGoalSpot: 5
    },
    scoring: {
        touchdown: 6,
        kickPAT: 1,
        runPAT: 2,
        safety: 2,
        rougePoints: 1,
        fieldGoal: 3,
        dropKickFieldGoal: 4,
        dropKickPAT: 2,
        deuce: 2,
        defensivePAT: 2,
        scoringPatScoreOption1: PatPoints.OptionOne.value,
        scoringPatScoreOption2: PatPoints.OptionTwo.value,
        scoringPatScoreOption3: PatPoints.OptionThree.value,
        playSummary: true
    }
});

export default DefaultIndoorConfig;
